import { render, staticRenderFns } from "./SearchArtistList.vue?vue&type=template&id=1992a370&"
import script from "./SearchArtistList.vue?vue&type=script&lang=js&"
export * from "./SearchArtistList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports